// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.hvf-admin-wrapper {
  height: 100vh;
  display: flex;
  flex-direction: column;
  padding: 6px;
}

.hvf-filter-group-input {
  width: 100%;
  height: 40px;
}

.hvf-filter-group-list {
  display: flex;
  flex-direction: column;
  height: auto;
}

.hvf-admin-top-bar {
  display: flex;
  padding: 6px;
  align-items: center;
}

.hvf-admin-header {
  flex: 1;
}

.create-hvf-filter-button {
  height: 40px;
  outline: none;
  border: none;
  background-color: rgb(159, 32, 137);
  border-radius: 4px;
  color: white;
}

table {
  font-family: arial, sans-serif;
  border-collapse: collapse;
  width: 100%;
}

th, td {
  border: 1px solid lightgray;
  text-align: left;
  padding: 8px;
  align-self: center;
}

#hvf-filter-table th {
  font-size: 16px;
}

.td-align-center {
  text-align: center;
}

.switch {
  position: relative;
  display: inline-block;
  width: 36px;
  height: 26.5px;
  margin-top: 4px;
}

.switch input { 
  opacity: 0;
  width: 0;
  height: 0;
}

.slider {
  position: absolute;
  cursor: pointer;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background-color: #ccc;
  -webkit-transition: .3s;
  transition: .3s;
}

.slider:before {
  position: absolute;
  content: "";
  height: 20px;
  width: 20px;
  left: 2px;
  bottom: 3px;
  background-color: white;
  -webkit-transition: .3s;
  transition: .3s;
}

input:checked + .slider {
  background-color: rgb(159, 32, 137);
}

input:focus + .slider {
  box-shadow: 0 0 1px rgb(159, 32, 137);
}

input:checked + .slider:before {
  -webkit-transform: translateX(11px);
  -ms-transform: translateX(11px);
  transform: translateX(11px);
}

.slider.round {
  border-radius: 34px;
}

.slider.round:before {
  border-radius: 50%;
}

.icon-color {
  color: rgb(159, 32, 137);
}

.show-more-button {
  height: 40px;
  width: fit-content;
  margin-top: 24px;
  background-color: rgb(159, 32, 137);
  border: none;
  outline: none;
  color: white;
  padding: 6px;
  border-radius: 6px;
  align-self: center;
}

.list-end {
  margin-top: 24px;
  align-self: center;
  font-weight: bold;
}

.filter-group-container {
  display: flex;
}

.filter-group-wrapper {
  flex: 1;
  border: 1px solid lightgray;
  height: 865px;
  padding: 12px;
  margin-right: 12px;
  margin-left: 6px;
}

.filter-search-input {
  display: flex;
  background-color: rgb(159, 32, 137);
  box-sizing: border-box;
  margin-bottom: 12px;
}

.fa-search, .fa-pencil {
  margin: 0px 12px;
  color: white;
  align-self: center;
}

.hvf-filters-wrapper {
  box-sizing: border-box;
  width: 100%;
  height: 600px;
  display: flex;
}

.add-hvf-filters {
  height: 100%;
  flex: 1;
  border: 1px solid lightgray;
  margin-right: 16px;
  padding: 6px;
  overflow-y: scroll;
}

.hvf-filter-search-list {
  height: 80px;
  padding: 12px;
  display: flex;
  align-items: center;
  margin-top: 12px;
  border: 1px solid lightgray;
}

.hvf-filter-thumbnail {
  width: 60px;
  height: 60px;
  border-radius: 50%;
  border-radius: 1px solid black;
  background-color: black;
  margin-right: 12px;
}

.hvf-filter-content {
  flex: 1;
}

.add-filter-group-button {
  border-radius: 50px;
  border: 4px solid rgb(159, 32, 137);
  outline: none;
  color: rgb(159, 32, 137);
  background-color: white;
}

.edit-hvf-filters {
  height: 100%;
  flex: 1;
  border: 1px solid lightgray;
  padding: 12px;
  overflow-y: scroll;
}

.remove-filter-group-button {
  border: none;
  background-color: white;
  outline: none;
}

.filter-group-valid {
  margin-top: 16px;
}

.filter-valid-radio-label {
  margin: 6px 60px 0px 0px;
}

.filter-valid-radio-input {
  margin-left: 6px;
}

.blank-space {
  height: 76px;
}

.create-button {
  position: relative;
  float: right;
  width: 90px;
  height: 40px;
  background-color: rgb(159, 32, 137);
  margin-left: 20px;
  border-radius: 4px;
  outline: none;
  border: 1px solid rgb(159, 32, 137);
  color: white;
  top: 30px;
}

.cancel-button {
  position: relative;
  float: right;
  width: 90px;
  height: 40px;
  border: 1px solid rgb(159, 32, 137);
  background-color: white;
  border-radius: 4px;
  outline: none;
}

.margin {
  top: 30px;
}

.margin-bottom {
  margin-bottom: 16px;
  font-weight: bold;
}

.empty-column {
  width: 300px;
  margin-right: 10px;
}`, "",{"version":3,"sources":["webpack://./client/components/dashboard/HVFAdmin/style/style.css"],"names":[],"mappings":"AAAA;EACE,aAAa;EACb,aAAa;EACb,sBAAsB;EACtB,YAAY;AACd;;AAEA;EACE,WAAW;EACX,YAAY;AACd;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,YAAY;AACd;;AAEA;EACE,aAAa;EACb,YAAY;EACZ,mBAAmB;AACrB;;AAEA;EACE,OAAO;AACT;;AAEA;EACE,YAAY;EACZ,aAAa;EACb,YAAY;EACZ,mCAAmC;EACnC,kBAAkB;EAClB,YAAY;AACd;;AAEA;EACE,8BAA8B;EAC9B,yBAAyB;EACzB,WAAW;AACb;;AAEA;EACE,2BAA2B;EAC3B,gBAAgB;EAChB,YAAY;EACZ,kBAAkB;AACpB;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,kBAAkB;EAClB,qBAAqB;EACrB,WAAW;EACX,cAAc;EACd,eAAe;AACjB;;AAEA;EACE,UAAU;EACV,QAAQ;EACR,SAAS;AACX;;AAEA;EACE,kBAAkB;EAClB,eAAe;EACf,MAAM;EACN,OAAO;EACP,QAAQ;EACR,SAAS;EACT,sBAAsB;EACtB,uBAAuB;EACvB,eAAe;AACjB;;AAEA;EACE,kBAAkB;EAClB,WAAW;EACX,YAAY;EACZ,WAAW;EACX,SAAS;EACT,WAAW;EACX,uBAAuB;EACvB,uBAAuB;EACvB,eAAe;AACjB;;AAEA;EACE,mCAAmC;AACrC;;AAEA;EACE,qCAAqC;AACvC;;AAEA;EACE,mCAAmC;EACnC,+BAA+B;EAC/B,2BAA2B;AAC7B;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,wBAAwB;AAC1B;;AAEA;EACE,YAAY;EACZ,kBAAkB;EAClB,gBAAgB;EAChB,mCAAmC;EACnC,YAAY;EACZ,aAAa;EACb,YAAY;EACZ,YAAY;EACZ,kBAAkB;EAClB,kBAAkB;AACpB;;AAEA;EACE,gBAAgB;EAChB,kBAAkB;EAClB,iBAAiB;AACnB;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,OAAO;EACP,2BAA2B;EAC3B,aAAa;EACb,aAAa;EACb,kBAAkB;EAClB,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,mCAAmC;EACnC,sBAAsB;EACtB,mBAAmB;AACrB;;AAEA;EACE,gBAAgB;EAChB,YAAY;EACZ,kBAAkB;AACpB;;AAEA;EACE,sBAAsB;EACtB,WAAW;EACX,aAAa;EACb,aAAa;AACf;;AAEA;EACE,YAAY;EACZ,OAAO;EACP,2BAA2B;EAC3B,kBAAkB;EAClB,YAAY;EACZ,kBAAkB;AACpB;;AAEA;EACE,YAAY;EACZ,aAAa;EACb,aAAa;EACb,mBAAmB;EACnB,gBAAgB;EAChB,2BAA2B;AAC7B;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,8BAA8B;EAC9B,uBAAuB;EACvB,kBAAkB;AACpB;;AAEA;EACE,OAAO;AACT;;AAEA;EACE,mBAAmB;EACnB,mCAAmC;EACnC,aAAa;EACb,wBAAwB;EACxB,uBAAuB;AACzB;;AAEA;EACE,YAAY;EACZ,OAAO;EACP,2BAA2B;EAC3B,aAAa;EACb,kBAAkB;AACpB;;AAEA;EACE,YAAY;EACZ,uBAAuB;EACvB,aAAa;AACf;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,wBAAwB;AAC1B;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,YAAY;AACd;;AAEA;EACE,kBAAkB;EAClB,YAAY;EACZ,WAAW;EACX,YAAY;EACZ,mCAAmC;EACnC,iBAAiB;EACjB,kBAAkB;EAClB,aAAa;EACb,mCAAmC;EACnC,YAAY;EACZ,SAAS;AACX;;AAEA;EACE,kBAAkB;EAClB,YAAY;EACZ,WAAW;EACX,YAAY;EACZ,mCAAmC;EACnC,uBAAuB;EACvB,kBAAkB;EAClB,aAAa;AACf;;AAEA;EACE,SAAS;AACX;;AAEA;EACE,mBAAmB;EACnB,iBAAiB;AACnB;;AAEA;EACE,YAAY;EACZ,kBAAkB;AACpB","sourcesContent":[".hvf-admin-wrapper {\n  height: 100vh;\n  display: flex;\n  flex-direction: column;\n  padding: 6px;\n}\n\n.hvf-filter-group-input {\n  width: 100%;\n  height: 40px;\n}\n\n.hvf-filter-group-list {\n  display: flex;\n  flex-direction: column;\n  height: auto;\n}\n\n.hvf-admin-top-bar {\n  display: flex;\n  padding: 6px;\n  align-items: center;\n}\n\n.hvf-admin-header {\n  flex: 1;\n}\n\n.create-hvf-filter-button {\n  height: 40px;\n  outline: none;\n  border: none;\n  background-color: rgb(159, 32, 137);\n  border-radius: 4px;\n  color: white;\n}\n\ntable {\n  font-family: arial, sans-serif;\n  border-collapse: collapse;\n  width: 100%;\n}\n\nth, td {\n  border: 1px solid lightgray;\n  text-align: left;\n  padding: 8px;\n  align-self: center;\n}\n\n#hvf-filter-table th {\n  font-size: 16px;\n}\n\n.td-align-center {\n  text-align: center;\n}\n\n.switch {\n  position: relative;\n  display: inline-block;\n  width: 36px;\n  height: 26.5px;\n  margin-top: 4px;\n}\n\n.switch input { \n  opacity: 0;\n  width: 0;\n  height: 0;\n}\n\n.slider {\n  position: absolute;\n  cursor: pointer;\n  top: 0;\n  left: 0;\n  right: 0;\n  bottom: 0;\n  background-color: #ccc;\n  -webkit-transition: .3s;\n  transition: .3s;\n}\n\n.slider:before {\n  position: absolute;\n  content: \"\";\n  height: 20px;\n  width: 20px;\n  left: 2px;\n  bottom: 3px;\n  background-color: white;\n  -webkit-transition: .3s;\n  transition: .3s;\n}\n\ninput:checked + .slider {\n  background-color: rgb(159, 32, 137);\n}\n\ninput:focus + .slider {\n  box-shadow: 0 0 1px rgb(159, 32, 137);\n}\n\ninput:checked + .slider:before {\n  -webkit-transform: translateX(11px);\n  -ms-transform: translateX(11px);\n  transform: translateX(11px);\n}\n\n.slider.round {\n  border-radius: 34px;\n}\n\n.slider.round:before {\n  border-radius: 50%;\n}\n\n.icon-color {\n  color: rgb(159, 32, 137);\n}\n\n.show-more-button {\n  height: 40px;\n  width: fit-content;\n  margin-top: 24px;\n  background-color: rgb(159, 32, 137);\n  border: none;\n  outline: none;\n  color: white;\n  padding: 6px;\n  border-radius: 6px;\n  align-self: center;\n}\n\n.list-end {\n  margin-top: 24px;\n  align-self: center;\n  font-weight: bold;\n}\n\n.filter-group-container {\n  display: flex;\n}\n\n.filter-group-wrapper {\n  flex: 1;\n  border: 1px solid lightgray;\n  height: 865px;\n  padding: 12px;\n  margin-right: 12px;\n  margin-left: 6px;\n}\n\n.filter-search-input {\n  display: flex;\n  background-color: rgb(159, 32, 137);\n  box-sizing: border-box;\n  margin-bottom: 12px;\n}\n\n.fa-search, .fa-pencil {\n  margin: 0px 12px;\n  color: white;\n  align-self: center;\n}\n\n.hvf-filters-wrapper {\n  box-sizing: border-box;\n  width: 100%;\n  height: 600px;\n  display: flex;\n}\n\n.add-hvf-filters {\n  height: 100%;\n  flex: 1;\n  border: 1px solid lightgray;\n  margin-right: 16px;\n  padding: 6px;\n  overflow-y: scroll;\n}\n\n.hvf-filter-search-list {\n  height: 80px;\n  padding: 12px;\n  display: flex;\n  align-items: center;\n  margin-top: 12px;\n  border: 1px solid lightgray;\n}\n\n.hvf-filter-thumbnail {\n  width: 60px;\n  height: 60px;\n  border-radius: 50%;\n  border-radius: 1px solid black;\n  background-color: black;\n  margin-right: 12px;\n}\n\n.hvf-filter-content {\n  flex: 1;\n}\n\n.add-filter-group-button {\n  border-radius: 50px;\n  border: 4px solid rgb(159, 32, 137);\n  outline: none;\n  color: rgb(159, 32, 137);\n  background-color: white;\n}\n\n.edit-hvf-filters {\n  height: 100%;\n  flex: 1;\n  border: 1px solid lightgray;\n  padding: 12px;\n  overflow-y: scroll;\n}\n\n.remove-filter-group-button {\n  border: none;\n  background-color: white;\n  outline: none;\n}\n\n.filter-group-valid {\n  margin-top: 16px;\n}\n\n.filter-valid-radio-label {\n  margin: 6px 60px 0px 0px;\n}\n\n.filter-valid-radio-input {\n  margin-left: 6px;\n}\n\n.blank-space {\n  height: 76px;\n}\n\n.create-button {\n  position: relative;\n  float: right;\n  width: 90px;\n  height: 40px;\n  background-color: rgb(159, 32, 137);\n  margin-left: 20px;\n  border-radius: 4px;\n  outline: none;\n  border: 1px solid rgb(159, 32, 137);\n  color: white;\n  top: 30px;\n}\n\n.cancel-button {\n  position: relative;\n  float: right;\n  width: 90px;\n  height: 40px;\n  border: 1px solid rgb(159, 32, 137);\n  background-color: white;\n  border-radius: 4px;\n  outline: none;\n}\n\n.margin {\n  top: 30px;\n}\n\n.margin-bottom {\n  margin-bottom: 16px;\n  font-weight: bold;\n}\n\n.empty-column {\n  width: 300px;\n  margin-right: 10px;\n}"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
